<div class="sme-status-section">
  <label>PECs Signed Off</label>
  <div class="sme-status-row">
    <div *ngFor="let step of stepStatuses"
         class="sme-status-item"
         [class.sme-status-on]="step.selected && !step.errorMessage"
         [class.sme-status-off]="!step.selected && !step.errorMessage"
         [class.sme-status-error]="!!step.errorMessage"
         [pTooltip]="step.errorMessage || ''"
         [tooltipDisabled]="!step.errorMessage"
         tooltipPosition="top">
      <i class="pi"
         [ngClass]="step.errorMessage ? 'pi-exclamation-circle' : (step.selected ? 'pi-check-circle' : 'pi-circle')"></i>
      <span>{{ step.label }}</span>
    </div>
  </div>
</div>
